import React from 'react';
import { Container, Typography } from '@mui/material';
import EmailInvitation from './EmailInvitation.png';
import CreateAnAccount from './CreateAnAccount.png';
import TwoFactorAuth from './TwoFactorAuth.png';

export default function TwoFactorAuthenticationEvidence() {
  return (
    <Container style={{ marginTop: '4em', marginBottom: '4em' }}>
      <Typography variant='h1' gutterBottom style={{ textAlign: 'center', width: '100%' }}>Two-Factor Authentication Evidence</Typography>
      <Typography variant='subtitle1' style={{ textAlign: 'center', width: '100%', fontWeight: 'bold', color: 'slategrey' }}>WearWare, Inc. (d/b/a FlyWire) • May 26, 2026</Typography>
      <Typography variant='subtitle1' style={{ textAlign: 'center', width: '100%', fontWeight: 'bold', color: 'slategrey' }}>portal.flywirecameras.com</Typography>

      <Typography variant='h2' style={{ marginTop: '1em' }}>Email Invitation</Typography>
      <img src={EmailInvitation} alt='Email Invitation' style={{ width: '100%', maxWidth: '600px', marginTop: '1em', marginBottom: '1em' }} />

      <Typography variant='h2' style={{ marginTop: '1em' }}>Create An Account</Typography>
      <img src={CreateAnAccount} alt='Create An Account' style={{ width: '100%', maxWidth: '600px', marginTop: '1em', marginBottom: '1em' }} />

      <Typography variant='h2' style={{ marginTop: '1em' }}>Two Factor Authentication</Typography>
      <img src={TwoFactorAuth} alt='Two Factor Authentication' style={{ width: '100%', maxWidth: '600px', marginTop: '1em', marginBottom: '1em' }} />
    </Container>
  );
}
